import { create } from "zustand";

export interface SensorInstall {
  id: string;
  siteId: string;
  label?: string;
  type: 'temperature' | 'humidity' | 'motion' | 'weight' | 'camera';
  pos: { x: number; y: number; z: number };
}

export interface SiteTransform {
  originOffsetX: number;
  originOffsetZ: number;
  rotationYRad: number;
  scale: number;
}

const DEFAULT_TRANSFORM: SiteTransform = {
  originOffsetX: 0,
  originOffsetZ: 0,
  rotationYRad: 0,
  scale: 1,
};

interface LayoutState {
  sensors: SensorInstall[];
  transform: SiteTransform;
  pendingTransform: SiteTransform | null;

  setSensors: (list: SensorInstall[]) => void;
  beginEdit: () => void;
  updatePending: (partial: Partial<SiteTransform>) => void;
  commitEdit: () => void;
  cancelEdit: () => void;
}

export const useLayoutStore = create<LayoutState>((set, get) => ({
  sensors: [],
  transform: { ...DEFAULT_TRANSFORM },
  pendingTransform: null,

  setSensors(list) {
    set({ sensors: list });
  },

  beginEdit() {
    set({ pendingTransform: { ...get().transform } });
  },

  updatePending(partial) {
    const cur = get().pendingTransform;
    if (!cur) return;
    set({ pendingTransform: { ...cur, ...partial } });
  },

  commitEdit() {
    const pending = get().pendingTransform;
    if (!pending) return;
    set({ transform: { ...pending }, pendingTransform: null });
  },

  cancelEdit() {
    set({ pendingTransform: null });
  },
}));
